import React from 'react';

import save from '../../../assets/icons/save.svg';
import bookmark from '../../../assets/icons/bookmark.svg';
import './SaveButton.scss';

interface Props {
  saved?: boolean;
  id: string;
  toggleSave: (id: string, saved: boolean) => void;
}

const SaveButton = ({ saved, id, toggleSave }: Props) => {
  return (
    <button
      className={`save-btn${saved ? ' activated' : ''}`}
      onClick={(event) => {
        event.stopPropagation();
        toggleSave(id, !saved);
      }}
    >
      <img
        src={saved ? bookmark : save}
        alt='save'
        className={saved ? 'white-filter' : 'grey-filter'}
      />
    </button>
  );
};

export default SaveButton;
